'use strict';

var NS = 'http://jabber.org/protocol/shim';


module.exports = function (client) {

    client.disco.addFeature(NS);
    client.disco.addFeature(NS + '#SubID', NS);
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/shim.js
// module id = 633
// module chunks = 2